const outservices = (state = [], action) => {
    switch (action.type) {
      case 'OUTSERVICE':
        return action.outservices
      default:
        return state
    }
  }
  
  export default outservices